import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';

const Navbar = () => {
  return (
    <AppBar color='primary' position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <img src={require('../assets/logo.png')} style={{height:'50px',width:'50px',marginRight:20}}/>
        <p className='font-black text-3xl'>Fixupnow Admin</p>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
